// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"bf6bd260","869":"d4117472"}[chunkId] + ".chunk.css";
};